module.exports = __webpack_public_path__ + "img/students-full-md.9046e866.jpg";